<template>
  <div>
    <v-dialog v-model="dialog" @keydown.esc="dialog = false" max-width="400px">
      <v-card>
        <v-form ref="form" lazy-validation>
          <v-card-title>
            <span class="headline"
              >{{ $t("import") }} {{ $t("main_file") }}
            </span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    v-model="mainfileData.file"
                    :label="
                      $t('main_file') + ' ' + $t('file').toLowerCase() + '*'
                    "
                    accept=".csv"
                    show-size
                    :rules="rules.required"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>

            <small>*{{ $t("indicates-required-field") }}</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="dialog = false">
              {{ $t("close") }}
            </v-btn>

            <v-btn
              color="primary"
              text
              @click="$refs.importConfirmDialog.dialog = true"
            >
              {{ $t("import") }}
            </v-btn>

            <ConfirmDialog
              ref="importConfirmDialog"
              :repeatString="'import'"
              @doFunction="importMainfilesFromCsv"
            ></ConfirmDialog>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/base/ConfirmDialog.vue";
import { importMainfilesFromCsv } from "@/endpoint/mainfile";

export default {
  name: "mainfileImportDialog",
  components: { ConfirmDialog },
  props: {
    isRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
      rules: {
        required: [(v) => !!v || this.$t("rule-required")],
      },
      mainfileData: {
        file: null,
      },
    };
  },
  methods: {
    importMainfilesFromCsv() {
      if (!this.$refs.form.validate()) {
        return;
      }

      importMainfilesFromCsv(this.mainfileData.file).then(() => {
        this.dialog = false;
        if (this.isRefresh) {
          this.$router.go();
        }
      });
    },
  },
};
</script>